/* eslint-disable max-len */
import React from 'react';

interface RedoAltProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const RedoAlt: React.FC<RedoAltProps> = ({ color, ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.9662 6.20162L15.3033 5.58468C12.3744 2.85889 7.62563 2.85889 4.6967 5.58468C1.76777 8.31047 1.76777 12.7299 4.6967 15.4557C7.62563 18.1814 12.3744 18.1814 15.3033 15.4557C17.0066 13.8705 17.7193 11.7126 17.4416 9.64814M15.9662 6.20162H11.9887M15.9662 6.20162V2.5"
      stroke={color ?? props?.style?.color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RedoAlt;
